(function () {
  'use strict';
  var root = document.documentElement;
  if (root.dataset.agmMotionEngine) return;
  root.dataset.agmMotionEngine = '2026-09-20-v2';
  var compact = window.matchMedia('(max-width: 749px)');
  var connection = navigator.connection;
  var lean = !!(connection && (connection.saveData || /(^|-)2g$/.test(connection.effectiveType)));
  var exclude = 'header, footer, dialog, form, .be, .blog-hero-header, .cart-drawer, .menu-drawer, [data-agsticky], .agpop, .ag-chat, .sn-page, .rg, .agp-gallery, .agp-details, [aria-live], [role="status"]';
  var groups = '.cgm__grid, .cg__grid, .cfg__steps, .ve__grid, .vag-inner, .product-grid, .cat-grid-all__grid, .multicolumn__grid, .pd__track, .cpn__grid, .rsw__muro, .cat-grid, .agp-jm__lista';
  var select = [
    '[data-gr-reveal]', '[data-gr-anim]', '.pd__header', '.pd__card', '.pd__cta-wrap',
    '.cgm__intro', '.cgm__item', '.cg__item', '.cfg__head', '.cfg__step', '.cfg__cta-wrap',
    '.ve__head', '.ve__card', '.ve__zones', '.vag-item', '.ag-planner-promo__inner',
    '.section-header__title', '.collection-seo-intro', '.blog-post-card',
    '.blog-card-premium', '.ag-card', '.product-card', '.agp-rcard', '.cat-card',
    '.cat-grid-all__item', '.rec-cover', '.rec-row', '.agp-trust',
    '.agp-info__head', '.agp-jm__resumen', '.agp-jm__item', '.agx', '.agcalc',
    '.multicolumn__item', '.icon-with-text__item', '.cpn__head', '.cpn__card',
    '.rsw__resumen', '.rsw__card'
  ].join(',');
  var seen = new WeakSet();
  var states = new WeakMap();
  var observed = new Set();
  var queue = new Set();
  var main, io;
  var queued = false;
  var disabled = !('IntersectionObserver' in window);
  var printing = false;

  function finish(el) {
    el.classList.remove('agm-motion-pending', 'agm-motion-enter');
    el.style.removeProperty('--agm-delay');
  }

  function reveal(el, animate, delay) {
    var state = states.get(el);
    if (!state) return;
    state.armed = false;
    state.last = performance.now();
    el.classList.remove('agm-motion-pending');
    if (animate && !document.hidden && !printing && !el.contains(document.activeElement)) {
      el.style.setProperty('--agm-delay', delay + 'ms');
      el.classList.add('agm-motion-enter');
    } else finish(el);
  }

  function release() {
    observed.forEach(finish);
  }

  function legacy(scope) {
    root.classList.remove('gr-reveal-on');
    var old = '[data-gr-reveal], [data-gr-stagger], [data-gr-anim], [data-gr-rv]';
    if (scope.matches && scope.matches(old)) scope.classList.add('gr-visible', 'gr-in');
    scope.querySelectorAll(old).forEach(function (el) {
      el.classList.add('gr-visible', 'gr-in');
    });
  }

  function collect(scope) {
    if (!scope || !scope.querySelectorAll) return;
    legacy(scope);
    var candidates = Array.from(scope.querySelectorAll(select));
    if (scope.matches && scope.matches(select)) candidates.unshift(scope);
    var chosen = new Set(candidates.filter(function (el) {
      return !seen.has(el) && !el.closest(exclude) && !el.matches(groups);
    }));
    var height = window.innerHeight;
    var width = window.innerWidth;
    var batch = [];
    chosen.forEach(function (el) {
      var ancestor = el.parentElement;
      while (ancestor && ancestor !== main) {
        if (chosen.has(ancestor) || ancestor.hasAttribute('data-agm-motion')) return;
        ancestor = ancestor.parentElement;
      }
      var rect = el.getBoundingClientRect();
      if (!rect.width || !rect.height) return;
      seen.add(el);
      var outside = rect.top >= height + 12 || rect.bottom < -12 || rect.left >= width + 12 || rect.right < -12;
      var kind = el.matches('.rsw__card, .agp-jm__item') ? 'review' :
        el.matches('.cgm__item, .cg__item, .cat-card, .cat-grid-all__item') ? 'media' :
        el.matches('.cfg__step') ? 'line' :
        el.matches('.product-card, .pd__card, .ag-card, .agp-rcard, .cpn__card, .ve__card, .vag-item') ? 'soft' : 'rise';
      batch.push({ el: el, outside: outside, kind: kind });
    });
    batch.forEach(function (item) {
      var el = item.el;
      el.setAttribute('data-agm-motion', item.kind);
      states.set(el, { armed: item.outside, last: item.outside ? -Infinity : performance.now() });
      if (disabled) return;
      observed.add(el);
      // The initial viewport remains fully readable, including LCP candidates.
      if (item.outside) el.classList.add('agm-motion-pending');
      io.observe(el);
    });
  }

  function safeCollect(scope) {
    try { collect(scope); } catch (error) {
      disabled = true;
      release();
      if (io) io.disconnect();
    }
  }

  function flush() {
    queued = false;
    queue.forEach(safeCollect);
    queue.clear();
    observed.forEach(function (el) {
      if (!el.isConnected) {
        if (io) io.unobserve(el);
        observed.delete(el);
      }
    });
  }

  function enqueue(scope) {
    if (!scope || !scope.isConnected) return;
    queue.add(scope);
    if (!queued) {
      queued = true;
      requestAnimationFrame(flush);
    }
  }

  function start() {
    main = document.getElementById('MainContent') || document.querySelector('main');
    if (!main) return;
    if (lean) root.classList.add('agm-motion-lean');
    root.classList.add('agm-motion-ready', 'agm-motion-v2');
    if (!disabled) {
      io = new IntersectionObserver(function (entries) {
        var order = new Map();
        entries.sort(function (a, b) {
          return a.boundingClientRect.top - b.boundingClientRect.top || a.boundingClientRect.left - b.boundingClientRect.left;
        });
        entries.forEach(function (entry) {
          var el = entry.target;
          var state = states.get(el);
          if (!state) return;
          if (!entry.isIntersecting) {
            // Rearm without hiding the element or running a background animation.
            state.armed = true;
            if (el.classList.contains('agm-motion-enter')) finish(el);
            return;
          }
          if (!state.armed && !el.classList.contains('agm-motion-pending')) return;
          var group = el.closest(groups) || el.parentElement;
          var index = order.get(group) || 0;
          order.set(group, index + 1);
          var cap = lean ? 30 : compact.matches ? 210 : 300;
          var replay = performance.now() - state.last > 8000;
          reveal(el, replay, Math.min(index * (compact.matches ? 85 : 100), cap));
        });
      }, { threshold: 0, rootMargin: '0px 0px -48px 0px' });
    }
    safeCollect(main);

    var photos = new WeakMap();
    main.querySelectorAll('img.agp-photo').forEach(function (el) {
      photos.set(el, el.currentSrc || el.src);
    });
    main.addEventListener('load', function (event) {
      var el = event.target;
      if (!el.matches || !el.matches('img.agp-photo')) return;
      var source = el.currentSrc || el.src;
      if (photos.has(el) && photos.get(el) !== source) el.classList.add('agm-photo-swap');
      photos.set(el, source);
    }, true);

    main.addEventListener('animationend', function (event) {
      if (event.target.classList.contains('agm-motion-enter') && /^agm/.test(event.animationName)) finish(event.target);
      if (event.animationName === 'agmPhotoSwap') event.target.classList.remove('agm-photo-swap');
    });
    function stopForInteraction(event) {
      var el = event.target.closest('.agm-motion-pending, .agm-motion-enter');
      if (el) reveal(el, false, 0);
    }
    main.addEventListener('focusin', stopForInteraction);
    main.addEventListener('pointerdown', stopForInteraction, { passive: true });
    main.addEventListener('click', function (event) {
      var more = event.target.closest('.rsw__vermas');
      if (more) enqueue(more.parentElement);
    });

    if ('MutationObserver' in window) {
      var mutation = new MutationObserver(function (records) {
        records.forEach(function (record) {
          record.addedNodes.forEach(function (node) {
            if (node.nodeType === 1 && !node.closest(exclude)) enqueue(node);
          });
          if (!queued && Array.prototype.some.call(record.removedNodes, function (node) { return node.nodeType === 1; })) {
            queued = true;
            requestAnimationFrame(flush);
          }
        });
      });
      mutation.observe(main, { childList: true, subtree: true });
    }
    document.addEventListener('shopify:section:load', function (event) { safeCollect(event.target); });
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) main.querySelectorAll('.agm-motion-enter').forEach(finish);
    });
    window.addEventListener('pageshow', function (event) {
      if (!event.persisted) return;
      observed.forEach(function (el) {
        var rect = el.getBoundingClientRect();
        if (rect.top < window.innerHeight && rect.bottom > 0) reveal(el, false, 0);
      });
    });
    window.addEventListener('beforeprint', function () { printing = true; release(); });
    window.addEventListener('afterprint', function () { printing = false; });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();

